import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import Pictures from './Pictures';
import indexScripts from './indexScripts';
import { notify, hideNotification, showSpinner, hideSpinner } from '../../../redux/actions';

function HotPoints(props) {
  const [hotPoints, setHotPoints] = useState(false);
  const [loadingError, setLoadingError] = useState(false);
  const { exercise, startStats, finishExercise, action, type } = props.exerciseProps;
  const context = null;
  const scripts = indexScripts(context);

  const play = (path, ev = null) => {
    action();
    if (ev) ev.stopPropagation();
    props.media.play(path);
  }

  const playWrong = () => {
    props.media.failure();
  }

  const playSuccess = () => {
    props.media.success();
  }

  const finish = () => {
    props.media.finish();
    finishExercise();
  }

  useEffect(() => {
    props.showSpinner('Trwa ładowanie ćwiczenia');
    startStats(type);
    scripts.preloadImages(exercise)
      .then(exerciseObj => setHotPoints(exerciseObj))
      .catch(e => setLoadingError(true))
      .finally(() => props.hideSpinner());
    // eslint-disable-next-line
  }, []);

  if (loadingError) return (
    <div style={{
      display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0
    }}>
      <h2>Przepraszamy, wystąpił błąd z załadowaniem ćwiczenia</h2>
    </div>
  );

  if (!hotPoints) return '';

  return (
    <>
      <Pictures
        hotPoints={hotPoints}
        play={play}
        playFailure={playWrong}
        playSuccess={playSuccess}
        finish={finish}
        expand={props.exerciseProps.expand}
        action={action}
        mobile={props.mobile}
      />
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    media: state.media,
    mobile: state.mobile,
  }
}

export default connect(mapStateToProps, { notify, hideNotification, showSpinner, hideSpinner })(HotPoints);
